import { CrmLifecycleStage } from '../../graphql/enums.graphql';

/** The slice of an Organization the pre-sale test reads. */
interface ProspectTestShape {
  lifecycleStage?: CrmLifecycleStage | null;
  subscriptions?: unknown[] | null;
}

/**
 * Whether an Organization record should be treated as pre-sale — the test that
 * decides between the client record (ViewOrganization, its billing sidebar
 * sections) and the prospect record (ViewProspect).
 *
 * Two conditions, both load-bearing:
 *
 * - **Lifecycle stage is not CLIENT.** An absent stage reads as CLIENT, matching
 *   the backend's own fallback for documents written before the CRM fields
 *   existed — a missing field must never demote a paying client.
 * - **No subscription on file.** Nothing flips `lifecycleStage` automatically
 *   today, so a prospect that signs would otherwise keep the prospect page and
 *   hide the subscription it just bought. The first subscription is the
 *   conversion, whatever the CRM stage still says.
 *
 * Kept in one place because the page and the sidebar have to agree: a record
 * showing the prospect page with Subscriptions and Billing still in the rail
 * would offer navigation to tabs that no longer exist.
 */
export function isProspectRecord(org: ProspectTestShape | null | undefined): boolean {
  if (!org) return false;
  return (
    (org.lifecycleStage ?? CrmLifecycleStage.Client) !== CrmLifecycleStage.Client &&
    (org.subscriptions?.length ?? 0) === 0
  );
}
